import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { getCurrencyData } from './currency&PriceUtil.js';
import { Tooltip } from 'react-tooltip';

import InfoIcon from '@mui/icons-material/Info';
import './css/OpportunityCreationPage.css';
import JWTErrorPopup from './JWTErrorPopup'; // Import the popup component
import { handleJWTResponse } from './jwtErrorHandler'; 
// const { APP_ID, APP_ICON, APP_MODULE_URL } = window.APP_CONFIG;
function OpportunityCreationPage2() {
    const location = useLocation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);

    const { firmName, selectedCurrency, firmId, accountId, email } = location.state;
    const [showJWTError, setShowJWTError] = useState(false);
            const [jwtErrorMessage, setJwtErrorMessage] = useState('');
        
            const closeJWTErrorPopup = () => {
                setShowJWTError(false);
                navigate('/firm');
            };
    
    const [users, setUsers] = useState([
        {
            firstName: '',
            lastName: '',
            username: '',
            isVerified: false,
            usernameToCopy: '',
            isVerifiedToCopy: false, 
            userEmail: '',
            traderEmailVerified: false,
            productType: '',
            recording: '',
            beepTone: '',
            recordingStorage: '',
            recordingRetentionValue: '',
            recordingRetentionUnit: '',
            localURI: '',
            dialtone: '',
            newUserExtension:'',
            additionalExtensions:'',
            sso: '',
            ssoUsername: '',
            notes: '',
            isCollapsed: false,
            errors: []
        },
    ]);

   

    const { symbol: currencySymbol, pricing } = getCurrencyData(selectedCurrency, 'New User Copy Request' );
    const { baseCostPerUser, services, productTypes, recordingStoragePrices, dialTonePrice, voiceRetentionPrice } = pricing;

    // Handle input changes for user fields
    const handleUserChange = (index, field) => (event) => {
        const updatedUsers = [...users];
        updatedUsers[index][field] = event.target.value;

        const errors = updatedUsers[index].errors.filter((error) => error !== field);
        updatedUsers[index].errors = errors;

        // If username is changed, reset verification status
       if (field === "username") {
            updatedUsers[index].isVerified = false;
        } else if (field === "usernameToCopy") {
            updatedUsers[index].isVerifiedToCopy = false;
        } else if (field === "userEmail"){
            updatedUsers[index].traderEmailVerified = false;
        }

        if (field === "firstName" || field === "lastName") {
            updatedUsers[index].username = generateUsername(updatedUsers[index].firstName, updatedUsers[index].lastName);
            updatedUsers[index].isVerified = false;
        }

        if(field === "recording" &&  updatedUsers[index].recording === 'No'){ 
          //  beepTone, recordingStorage, recordingRetentionValue, recordingRetentionUnit, localURI
          updatedUsers[index].beepTone = '';
          updatedUsers[index].recordingStorage = '';
          updatedUsers[index].recordingRetentionValue = '';
          updatedUsers[index].recordingRetentionUnit = '';
          updatedUsers[index].localURI = '';

        }

        setUsers(updatedUsers);
    };

    const generateUsername = (firstName, lastName) => {
        if (firstName && lastName) {
            return `${firstName}${lastName}`.toLowerCase(); // Combine without spaces
        }
        return ''; // Return empty if either field is missing
    };

    // Handle selection of product type
    const handleProductTypeChange = (index) => (event) => {
        const updatedUsers = [...users];
        updatedUsers[index].productType = event.target.value;
        setUsers(updatedUsers);
    };


    // Add a new user
    const handleAddUser = () => {
        if (users.length < 5) {
        setUsers([
            ...users,
            {
                firstName: '',
                lastName: '',
                username: '',
                isVerified: false,
                usernameToCopy: '',
                isVerifiedToCopy: false, 
                userEmail: '',
                traderEmailVerified: false,
                productType: '',
                recording: '',
                beepTone: '',
                recordingStorage: '',
                recordingRetentionValue: '',
                recordingRetentionUnit: '',
                localURI: '',
                dialtone: '',
                newUserExtension:'',
                additionalExtensions:'',
                sso: '',
                ssoUsername: '',
                notes: '',
                isCollapsed: false,
                errors: []
            },
        ]);
    }else {
        alert('You can only add up to 5 users. If you need to add more than 5 users, please contact sales@symphony.com');

    }
    };

    // Remove a user by index
    const handleRemoveUser = (index) => {
        setUsers(users.filter((_, i) => i !== index));
    };

    // Handle collapsing a user's form
    const handleCollapseUser = (index) => () => {
        const updatedUsers = [...users];
        updatedUsers[index].isCollapsed = true;
        setUsers(updatedUsers);
    };

    // Handle expanding a user's form
    const handleExpandUser = (index) => () => {
        const updatedUsers = [...users];
        updatedUsers[index].isCollapsed = false;
        setUsers(updatedUsers);
    };

    // Calculate total cost for a single user
    const calculateTotalForUser = (user) => {
        const productCost = productTypes.find((p) => p.id === user.productType)?.cost || 0;
        // const userServiceCost = user.selectedServices.reduce((sum, serviceId) => {
        //     const service = services.find((s) => s.id === serviceId);
        //     return sum + (service ? service.cost : 0);
        // }, 0);
        const recordingStorageCost =  user.recording === 'Yes' ? recordingStoragePrices[user.recordingStorage] || 0 : 0 ;
        const dialtoneCost = user.dialtone === 'Yes' ? dialTonePrice : 0;
        const recordingRetentionPrice = user.recording === 'Yes' ? voiceRetentionPrice : 0;
        //return baseCostPerUser + productCost + userServiceCost + recordingStorageCost;
        // return baseCostPerUser + productCost  + recordingStorageCost + dialtoneCost + recordingRetentionPrice;
        return productCost  + recordingStorageCost + dialtoneCost + recordingRetentionPrice;
        
    };

    const totalProvisionCost = users.length * baseCostPerUser;

    const totalProductCost = users.reduce((sum, user) => {
        const productCost = productTypes.find((p) => p.id === user.productType)?.cost || 0;
        return sum + productCost;
        }, 0);

    const totalRecordingStorageCost = users.reduce((sum, user) => {
            const recordingStorageCost = user.recording === 'Yes' ? recordingStoragePrices[user.recordingStorage] || 0 : 0 ;
            // {recordingStoragePrices[user.recordingStorage] || 0}
            return sum + recordingStorageCost;
        }, 0);

     
    const totalDialtoneCost = users.reduce((sum, user) => {
            // If user.dialtone === 'Yes', add dialtonePrice
            return sum + (user.dialtone === 'Yes' ? dialTonePrice : 0);
          }, 0);
    const totalRecodingRetentionCost = users.reduce((sum, user) => {
            // If user.recording === 'Yes', add voiceRetentionPrice
            return sum + (user.recording === 'Yes' ? voiceRetentionPrice : 0);
          }, 0);
    const totalProductCostForSummary = totalProductCost + totalRecordingStorageCost +   totalDialtoneCost + totalRecodingRetentionCost;
    // const totalCost = totalProvisionCost + totalProductCost  + totalRecordingStorageCost + totalDialtoneCost + totalRecodingRetentionCost;
    const totalCost = totalProductCost  + totalRecordingStorageCost + totalDialtoneCost + totalRecodingRetentionCost;
    
    

    // Calculate total cost for all users
    const calculateTotalCost = () => {
        return users.reduce((total, user) => total + calculateTotalForUser(user), 0);
    };

    const handleVerifyUsername = (index) => {
        const username = users[index].username;

        fetch(`https://cloud9requests.symphony.com/requests/api/verify_username`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ username }),
        })
            .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
            .then((data) => {
                const updatedUsers = [...users];
                updatedUsers[index].isVerified = data.isAvailable;
                setUsers(updatedUsers);
            })
            .catch(error => {
                if (error.message !== "JWT error handled") {
                    console.error('Error fetching Username:', error);
                }
            });
    };
    const handleVerifyEmail = (index) => {
        const userEmail = users[index].userEmail;

        fetch(`https://cloud9requests.symphony.com/requests/api/validate_email`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ userEmail }),
        })
            .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
            .then((data) => {
                const updatedUsers = [...users];
                updatedUsers[index].traderEmailVerified = data.isAvailable;
                setUsers(updatedUsers);
            })
            .catch(error => {
                if (error.message !== "JWT error handled") {
                    console.error('Error fetching Email Validation:', error);
                }
            });
    };

    const handleVerifyUsernameToCopy = (index) => {
        const usernameToCopy = users[index].usernameToCopy;

        fetch(`https://cloud9requests.symphony.com/requests/api/verify_username`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({ username: usernameToCopy }),
        })
            .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
            .then((data) => {
                const updatedUsers = [...users];
                updatedUsers[index].isVerifiedToCopy = !data.isAvailable;
                setUsers(updatedUsers);
            })
            .catch(error => {
                if (error.message !== "JWT error handled") {
                    console.error('Error fetching username to Copy:', error);
                }
            });
    };

    const fieldLabels = {
        firstName: "First Name",
        lastName: "Last Name",
        username: "Username not verified, must be unique",
        usernameToCopy : "Username to be copied is not verified or Empty",
        userEmail: "Email Address is empty or not unique",
        productType: "Product Type",
        recording: "Recording",
        officeAddress: "Office Address",
        ssoUsername: "SSO Username",
        notes: "Notes",
        recordingRetention: "Recording Retention must be at least 3 days.",
        traderEmailVerified : "Trader email not unique or empty"
    };
    const handleOkClick = (index) => {
        const user = users[index];
        const requiredFields = ["firstName", "lastName", "username","usernameToCopy", "userEmail", "productType", "recording"];
        const errors = requiredFields.filter((field) => !user[field]);


        if (!user.isVerified) {
            errors.push("username");
        }

        if (!user.isVerifiedToCopy) {
            errors.push("usernameToCopy");
        }
        if (!user.traderEmailVerified) {
            errors.push("userEmail");
        }

        if (user.recording === 'Yes') {
            if (!user.recordingRetentionValue || !user.recordingRetentionUnit) {
              errors.push("recordingRetention");
            } 
            // 2) If the user chose "Days" but typed < 3
            else if (
              user.recordingRetentionUnit === "Days" && 
              parseInt(user.recordingRetentionValue, 10) < 3
            ) {
              errors.push("recordingRetention");
            }
          }

        const updatedUsers = [...users];
        updatedUsers[index].errors = errors;
        setUsers(updatedUsers);

        if (errors.length === 0) {
            // Collapse the form if no errors
            handleCollapseUser(index)();
        }
    };

    const usersWithCost = users.map(user => {

        const productCost =
          productTypes.find((p) => p.id === user.productType)?.cost || 0;
        const recordingStorageCost =
        user.recording === 'Yes' ? recordingStoragePrices[user.recordingStorage] || 0 : 0 ;
        const dialtoneCost = user.dialtone === 'Yes' ? dialTonePrice : 0;
        // const provisioningCost = baseCostPerUser; // if each user always pays this
        const provisioningCost = 0;
        const recordingRetentionCost = user.recording === 'Yes' ? voiceRetentionPrice : 0;
      
        // 2) Compute total
        const totalPerUser =
        calculateTotalForUser(user);
      
        // 3) Return the merged object
        return {
          ...user,
          provisioningCost,
          productCost,
          dialtoneCost,
          recordingRetentionCost,
          recordingStorageCost,
          totalPerUser,
        };
      });


    const handleSubmit = () => {
        const anyOpenOrError = users.some((u) => !u.isCollapsed || u.errors.length > 0);

        if (anyOpenOrError) {
          alert("Please click OK on all users before submitting.");
          return;
        }
        setIsConfirmOpen(true);
       
    };
    const handleConfirmYes = () => {
        setIsConfirmOpen(false);

        // 3) Proceed with the fetch
        setLoading(true);
        fetch('https://cloud9requests.symphony.com/requests/api/create_opportunity', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                firmId: firmId,
                accountId: accountId,
                // billingEntity: selectedEntity.Id,
                billingEntityCurrency: selectedCurrency,
                firmName : firmName,
                requestType : 'New User Copy Request',
                email : email, 
                users: usersWithCost,
                totalMRR :  totalProductCostForSummary,
                totalCost: calculateTotalCost(),
            }),
        })
        .then(response => handleJWTResponse(response, setJwtErrorMessage, setShowJWTError))
        .then((data) => {
            console.log('Opportunity created:', data);
            setLoading(false);
            navigate('/summary', { state: { data } });
        })
        .catch(error => {
            if (error.message !== "JWT error handled") {
                console.error('Error creating Opportunity:', error);
            }
            setLoading(false); 
        });
    };

    return (
                    <div className="opportunity-page">
                        {/* <Link to="/billingEntity" className="back-link">
                            Back
                        </Link> */}
                                                 {/* JWT Error Popup */}
                        {showJWTError && (
                            <JWTErrorPopup 
                                message={jwtErrorMessage} 
                                onClose={closeJWTErrorPopup} 
                               />
                                )}
                        <button
                    onClick={() => {
                                navigate('/optionsPage', {
                                    state: { 
                                        firmName,
                                        selectedCurrency,
                                        firmId,
                                        accountId, 
                                        email
                                    }
                                });
                            }}
                            className="back-link"
                        >
                            Back
                        </button>
                        <div className="opportunity-container">
                            <img
                                src = "https://cloud9requests.symphony.com/Cloud9_Logo.png"
                                alt="C9 Logo"
                                className="logo"
                            />
                            <h2 className="form-title">Submit User Request</h2>
                            <h3 className="firm-details">
                                Firm Name: {firmName} | Currency: {selectedCurrency} <br /><br /><br />
                                This option is to create a new Users and new users will have the same Address, Settings, Recording Options, Groups and Neighbors as an existing user.
                            </h3>

                <div className="form-section">
                    {users.map((user, index) => (
                        <div key={index}>
                            {user.isCollapsed ? (
                                // Render collapsed view
                                <div className="collapsed-user">
                                    <p>
                                    <strong>User {index + 1}:</strong> {user.firstName} {user.lastName}<br/><strong>Cost :  {currencySymbol}{calculateTotalForUser(user)}</strong>
                                    </p>
                                    <button onClick={handleExpandUser(index)} className="edit-button">
                                        Edit
                                    </button>
                                </div>
                            ) : (
                                // Render full form
                                <div className="user-row">
                                    <div className="user-details">
                                        <h3>User Information</h3>
                                        <label>
                                            Trader First Name <span style={{ color: 'red'}}>&#42;</span> :
                                            <input
                                                type="text"
                                                value={user.firstName}
                                                onChange={handleUserChange(index, 'firstName')}
                                                required
                                            />
                                        </label>
                                        <label>
                                           Trader Last Name<span style={{ color: 'red'}}>&#42;</span>:
                                            <input
                                                type="text"
                                                value={user.lastName}
                                                onChange={handleUserChange(index, 'lastName')}
                                                required
                                            />
                                        </label>
                                        {/* <label>
                                           Trader Username<span style={{ color: 'red'}}>&#42;</span>:
                                            <input
                                                type="text"
                                                value={user.username}
                                                onChange={handleUserChange(index, 'username')}
                                                required
                                            />
                                        </label> */}
                                    <label>
                                    Trader Username <span style={{ color: "red" }}>&#42;</span>:
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <input
                                            type="text"
                                            value={user.username}
                                            onChange={handleUserChange(index, "username")}
                                            required
                                        />
                                        <button
                                            onClick={() => handleVerifyUsername(index)}
                                            className="add-user-button"
                                            style={{ marginLeft: "10px" }}
                                        >
                                            Verify
                                        </button>
                                    </div>
                                    {user.isVerified ? (
                                        <p style={{ color: "green", marginTop: "5px" }}>Username is available</p>
                                    ) : (
                                        <p style={{ color: "red", marginTop: "5px" }}>
                                            {user.username ? "Username not verified, must be unique" : ""}
                                        </p>
                                    )}
                                </label>
                                <label>
                                            Username to Copy <span style={{ color: "red" }}>&#42;</span>:
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <input
                                                    type="text"
                                                    value={user.usernameToCopy}
                                                    onChange={handleUserChange(index, "usernameToCopy")}
                                                    required
                                                />
                                                <button
                                                    onClick={() => handleVerifyUsernameToCopy(index)}
                                                    className="add-user-button"
                                                    style={{ marginLeft: "10px" }}
                                                >
                                                    Verify
                                                </button>
                                            </div>
                                            {user.isVerifiedToCopy ? (
                                                <p style={{ color: "green", marginTop: "5px" }}>
                                                    Username to copy is validated.
                                                </p>
                                            ) : (
                                                <p style={{ color: "red", marginTop: "5px" }}>
                                                    {user.usernameToCopy ? "Username to copy not verified" : ""}
                                                </p>
                                            )}
                                        </label>
                                
                                        <label>
                                            Trader Email<span style={{ color: 'red'}}>&#42;</span>:
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                            <input
                                                type="email"
                                                value={user.userEmail}
                                                onChange={handleUserChange(index, 'userEmail')}
                                                required
                                            />
                                            <button
                                            onClick={() => handleVerifyEmail(index)}
                                            className="add-user-button"
                                            style={{ marginLeft: "10px" }}
                                        >
                                            Verify
                                        </button>
                                        </div>
                                        {user.traderEmailVerified ? (
                                        <p style={{ color: "green", marginTop: "5px" }}>Email is unique</p>
                                            ) : (
                                        <p style={{ color: "red", marginTop: "5px" }}>
                                            {user.userEmail ? "Email not verified, must be unique" : ""}
                                        </p>
                                            )}
                                        </label>
                                        <label>
                                            Product Type<span style={{ color: 'red'}}>&#42;</span>:
                                            <select
                                                value={user.productType}
                                                onChange={handleProductTypeChange(index)}
                                            >
                                                <option value="">Select Product Type</option>
                                                {productTypes.map((product) => (
                                                    <option key={product.id} value={product.id}>
                                                        {product.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </label>
                                        <label>
                                            Voice Recording<span style={{ color: 'red'}}>&#42;</span>:
                                            <select
                                                value={user.recording}
                                                onChange={handleUserChange(index, 'recording')} required
                                            >
                                                <option value="">Select</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                            
                                        </label>
                                        {user.recording === 'Yes' && (
                                            <>  
                                                <label className="retention-label">
                                                    Recording Retention<span style={{ color: 'red'}}>&#42;</span>:
                                                    <div className="retention-inputs">
                                                        <input
                                                        type="number"
                                                        value={user.recordingRetentionValue}
                                                        onChange={handleUserChange(index, 'recordingRetentionValue')}
                                                        placeholder="e.g., 3"
                                                        min="3"
                                                        style={{ width: '80px', marginRight: '8px' }} 
                                                        />
                                                        <select
                                                        style={{ width: '327px', marginLeft: '8px' }} 
                                                        value={user.recordingRetentionUnit}
                                                        onChange={handleUserChange(index, 'recordingRetentionUnit')}
                                                        >
                                                         <option value="">Select</option>
                                                        <option value="Days">Days</option>
                                                        <option value="Months">Months</option>
                                                        <option value="Years">Years</option>
                                                        </select>
                                                    </div>
                                                </label>
                                                <label>
                                                Beep Tone<span style={{ color: 'red'}}>&#42;</span>:
                                                    <select
                                                        value={user.beepTone}
                                                        onChange={handleUserChange(index, 'beepTone')}
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                    </select>
                                                </label>
                                                <label>
                                                    Recordings Storage:
                                                    <select
                                                        value={user.recordingStorage}
                                                        onChange={handleUserChange(
                                                            index,
                                                            'recordingStorage'
                                                        )}
                                                    >
                                                        <option value="">Select</option>
                                                       
                                                    <option value="Cloud">Cloud </option>
                                                    <option value="Local">Local</option>
                                                    <option value="CloudLocal">Both (Cloud & Local)</option>
                                                    </select>
                                                </label>
                                                {(user.recordingStorage === 'Local' ||
                                                    user.recordingStorage === 'CloudLocal') && (
                                                    <label>
                                                        Local URI for Recordings:
                                                        <input
                                                            type="text"
                                                            value={user.localURI}
                                                            onChange={handleUserChange(index, 'localURI')}
                                                        />
                                                    </label>
                                                )}
                                            </>
                                        )}
                                        <label>
                                            Cloud Dial Tone<span style={{ color: 'red'}}>&#42;</span> :
                                            <select
                                                value={user.dialtone}
                                                onChange={handleUserChange(index, 'dialtone')} required
                                            >
                                                <option value="">Select</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </label>
                                        {user.dialtone === 'Yes' && (
                                            <>
                                            <label>
                                            New User DDI<span style={{ color: 'red'}}>&#42;</span>:
                                              <input
                                                  type="text"
                                                  value={user.newUserExtension}
                                                  onChange={handleUserChange(index, 'newUserExtension')}
                                                  
                                              />
                                          </label>
                                          <label>
                                          Additional Extensions<span style={{ color: 'red'}}>&#42;</span>
                                          <span className="info-icon" data-tooltip-id="additionalExtensions">
                                            <InfoIcon className="info-icon" />
                                            </span>
                                            <Tooltip
                                                id="additionalExtensions"
                                                content="To enter multiple extensions, the extensions should be comma separated"
                                                place="top"
                                            />:
                                              <input
                                                  type="text"
                                                  value={user.additionalExtensions}
                                                  onChange={handleUserChange(index, 'additionalExtensions')}
                                                  
                                              />
                                          </label>
                                            
                                            </>
                                        )}
                                       
                                        <label>
                                            SSO Enabled<span style={{ color: 'red'}}>&#42;</span> :
                                            <select
                                                value={user.sso}
                                                onChange={handleUserChange(index, 'sso')} required
                                            >
                                                <option value="">Select</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </label>
                                        {(user.sso === 'Yes' && 
                                             <label>
                                             If SSO Enabled, provide SSO Username<span style={{ color: 'red'}}>&#42;</span>:
                                              <input
                                                  type="text"
                                                  value={user.ssoUsername}
                                                  onChange={handleUserChange(index, 'ssoUsername')}
                                                  required
                                              />
                                          </label>
                                        )}
                                       
                                        <label>
                                          Notes<span style={{ color: 'red'}}>&#42;</span>:
                                            <input
                                                type="text"
                                                value={user.notes}
                                                onChange={handleUserChange(index, 'notes')}
                                                required
                                            />
                                        </label>
                                        {user.errors.length > 0 && (
                                            <div style={{ color: "red", marginTop: "10px" }}>
                                                <p>Please fill in the following fields:</p>
                                                <ul>
                                                {user.errors.map((error, i) => (
                                                    <li key={i}>{fieldLabels[error]}</li>
                                                ))}
                                            </ul>
                                            </div>
                                        )}
                                        <button
                                    onClick={() => handleOkClick(index)}
                                    className="add-user-button"
                                    // disabled={isOkButtonDisabled(user)}
                                >
                                    OK
                                </button>
                                        {index > 0 && (
                                            <button
                                                onClick={() => handleRemoveUser(index)}
                                                className="remove-user-button"
                                            >
                                                Remove User
                                            </button>
                                        )}
                                    </div>

                                    <div className="rate-card">
                                        <h3>Rate Card</h3>
                                        <div className="rate-details">
                                        {/* <p>
                                                <strong>One Time Cost:</strong><br/>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Provisioning Cost:</strong> {currencySymbol}{baseCostPerUser}
                                            </p> */}
                                            <p>
                                                <strong>Monthly Recurring Costs:</strong><br/>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Product Cost:</strong> {currencySymbol}
                                                {productTypes.find((p) => p.id === user.productType)?.cost ||
                                                    0} 
                                                 {(user.recording === 'Yes' && <p>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Recording Storage Cost:</strong> {currencySymbol}
                                                {recordingStoragePrices[user.recordingStorage] || 0}
                                            </p>)}
                                            {(user.recording === 'Yes' && <p>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Recording Retention Cost:</strong> {currencySymbol}
                                                    {voiceRetentionPrice}
                                                
                                            </p>)}
                                            {(user.dialtone === 'Yes' && <p>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>Dial Tone Cost:</strong> {currencySymbol}
                                                    {dialTonePrice}
                                                
                                            </p>)}  
                                            </p>
                                            {/* <h5>Additional Services</h5>
                                            {services.map((service) => (
                                                <label key={service.id} className="service-option">
                                                    <input
                                                        type="checkbox"
                                                        checked={user.selectedServices.includes(service.id)}
                                                        onChange={() => handleServiceToggle(index, service.id)}
                                                    />
                                                    {service.name} - {currencySymbol}{service.cost}
                                                </label>
                                            ))} */}
                                            <p>
                                                <strong>Total for User:</strong> {currencySymbol}
                                                {calculateTotalForUser(user)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                    
                    <button onClick={handleAddUser} className="add-user-button">
                        Add Additional Users
                    </button>
                </div>

                <div className="total-cost">
                    <h3>Cost Summary</h3>
                    {/* <p>One Time Charge (All Users): {currencySymbol}{totalProvisionCost}</p> */}
                    <p>Monthly Recurring Charges (All Users): {currencySymbol}{totalProductCostForSummary}</p>
                    {/* <p>Services Cost (All Users): {currencySymbol}{totalServicesCost}</p> */}
                    <p>
                        <strong>Total Cost:</strong> {currencySymbol}{totalCost}
                    </p>
                </div>
                {loading ? (
                    <div className="loading-container">
                        <p>Processing... Please wait</p>
                        <div className="spinner"></div> {/* Add spinner */}
                    </div>
                    ) : (
                    <button onClick={handleSubmit} className="submit-button">
                        Submit
                    </button>       
                    )}
                 {isConfirmOpen && (
                        <div className="modal-overlay">
                          <div className="modal-content">
                            <h3>Confirm Submission</h3>
                            <p>By submitting this form you are agreeing to the associated costs</p>
                            <p>Are you sure you want to submit?</p>
                           
                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                              <button onClick={handleConfirmYes}>Yes</button>
                              <button onClick={() => setIsConfirmOpen(false)}>No</button>
                            </div>
                          </div>
                        </div>
                      )}
            </div>
        </div>
    );
}

export default OpportunityCreationPage2;

